<template>
    <div class="main">
        <div class="">
            <div class="wisdom title ptr" v-if="!showButtons" @click="denyEverythingClicked">
                DENY EVERYTHING
            </div>
            <div class="buttons" v-if="showButtons">
                <a @click="whenDidWeFormClicked"><span>WHEN DID WE FORM?</span></a>
                <a @click="whenceTheNameClicked"><span>WHENCE THE NAME?</span></a>
            </div>
            <div class="comingsoon" v-if="showCs">
                CHECK BACK LATER FOR INFORMATIONS
            </div>
        </div>
    </div>

</template>

<script>
export default {
    data() {
        return {
            showButtons: false,
            showCs: false
        };
    },

    methods: {
        denyEverythingClicked() {
            this.showButtons = true;
        },

        whenDidWeFormClicked() {
            this.showCs = true;
        },

        whenceTheNameClicked() {
            this.showCs = true;
        }
    }
}
</script>

<style scoped>
.buttons {
    display: flex;
}
.buttons a {
    padding: 0.65em 0.1em;
    font-size: 5vw;
    width: 100%;
    text-align: center;
    cursor: pointer;
    display: block;
}

.buttons a span {
    font-size: 2.5vw;
    vertical-align: middle;
}

.comingsoon {
    text-align: center;
    font-size: 2vw;
    padding: 1em;
    background: #111;
    color: #aaa;
}
</style>



// WEBPACK FOOTER //
// src/components/DenyEverything.vue